import { EventEmitter } from '../util/eventemitter';

global.HOT_ICON_TYPE = {
  EMPTY: 0,
  ITEM: 1,
  COMMAND: 2,
  SKILL: 3,
  EMOTE: 4,
  DIALOG: 5,
  CLAN_SKILL: 6
};

export class HotIconsIcon {
  type: any;
  slot: any;

  constructor(type: any, slot: any) {
    this.type = type;
    this.slot = slot;
  }
}

export class HotIcons extends EventEmitter {
  icons: any[];

  static Icon = HotIconsIcon;

  constructor() {
    super();
    this.icons = [];
  }

  setIcon(id: any, type: any, slot: any) {
    const icon = this.icons[id];
    icon.type = type;
    icon.slot = slot;
    this.emit('changed', [id]);
  }

  setIcons(icons: any) {
    this.icons = icons;
    this.emit('changed');
  }
}

